import { Injectable } from '@angular/core';
import { TenantFeatureFlagResponseDto, TenantFeatureFlagService } from '@core/api';
import { BehaviorSubject, firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagsService {
  private featureFlagsSubject = new BehaviorSubject<TenantFeatureFlagResponseDto[] | null | undefined>(undefined);

  constructor(private featureFlagService: TenantFeatureFlagService) {}

  async loadFeatureFlags(tenantId: string): Promise<void> {
    return firstValueFrom(this.featureFlagService.v1TenantTenantIdFeatureFlagGet(tenantId))
      .then(response => {
        this.featureFlagsSubject.next(response.data);
      })
      .catch(error => {
        console.error('Error loading configuration', error);
      });
  }

  getFeatureFlags(): TenantFeatureFlagResponseDto[] | null | undefined {
    return this.featureFlagsSubject.value;
  }

  isFeatureEnabled(key: string): boolean {
    const tenantFeatureFlags = this.getFeatureFlags();
    if (tenantFeatureFlags?.some(ff => ff.key === key)) return true;
    else return false;
  }
}
